<template>
  <div class="college-page">
    <!-- 信息确认页面 -->
    <div v-if="showConfirmation" class="confirmation-page">
      <!-- 头部banner区域 -->
      <div class="header-banner">
        <div
          class="banner-content"
          :class="{ 'without-college-logo': collegeName[productId].showLogo === false }"
        >
          <!-- 原 Banner 保留，恢复方式见 config.js 的 showShandongUniversityLogo 开关。 -->
          <img
            :src="collegeName[productId].logo"
            :alt="collegeName[productId].showLogo === false ? '' : collegeName[productId].name"
            class="banner-image"
          />
          <div
            v-if="collegeName[productId].showLogo === false"
            class="banner-titles"
          >
            <p class="banner-project-title">新未来健康工程</p>
            <p class="banner-entry-title">客户信息录入</p>
          </div>
        </div>
      </div>

      <div class="confirmation-content">
        <!-- 信息确认标题 -->
        <div class="form-section">
          <div class="section-title">
            <div class="title-line"></div>
            <span class="title-text">信息确认</span>
            <div class="title-line"></div>
          </div>
        </div>

        <div
          v-for="customer in customerList"
          :key="customer.id"
          class="customer-confirmation-card"
        >
          <div class="customer-header">
            <h3 class="customer-name">{{ customer.personName }}</h3>
            <div class="total-amount" v-if="customer.isStorage">
              <span v-if="orgId != 10683">总金额：</span>
              <span v-if="orgId == 10683">定金：</span>
              <span class="amount">¥{{ getCustomerPrice(customer) }}</span>
            </div>
            <div class="total-amount" v-else-if="customer.isDetection && !customer.isStorage">
              <span class="amount">{{ detectionLabel }}</span>
            </div>
            <div class="total-amount" v-else-if="customer.isStorage && customer.isDetection">
              <span v-if="orgId != 10683">总金额：</span>
              <span v-if="orgId == 10683">定金：</span>
              <span class="amount">¥{{ getCustomerPrice(customer) }}</span>
            </div>
          </div>

          <div class="product-info">
            <template v-if="customer.isStorage && customer.isDetection">
              新未来健康工程
              <span class="product-term">{{
                getProductTerm(customer.productId)
              }}</span>
              <span style="margin-left: 10px;">+ {{ detectionLabel }}</span>
            </template>
            <template v-else-if="customer.isStorage">
              新未来健康工程
              <span class="product-term">{{
                getProductTerm(customer.productId)
              }}</span>
            </template>
            <template v-else-if="customer.isDetection">
              新未来健康工程 - {{ detectionLabel }}
            </template>
          </div>

          <div class="customer-details">
            <div class="detail-item">身份证号: {{ customer.personIdCard }}</div>
            <div class="detail-item">手机号: {{ customer.personPhone }}</div>
            <div class="detail-item">订单编号: {{ customer.orderNo }}</div>
            <div class="detail-item">订单时间: {{ orderData.orderTime }}</div>
          </div>
        </div>

        <!-- 合计金额 -->
        <div class="total-summary" v-if="hasStorageType">
          <div class="total-label">合计应付金额：</div>
          <div class="total-value">¥{{ getTotalAmount }}</div>
        </div>

        <!-- 底部按钮 -->
        <div class="confirmation-buttons">
          <button class="btn btn-back" @click="goBack">返回修改</button>
          <button class="btn btn-pay" :disabled="!quoteReady || loading" @click="goToPay">{{ getPayButtonText }}</button>
        </div>
      </div>
    </div>

    <!-- 原始表单页面 -->
    <div v-else>
      <!-- 头部banner区域 -->
      <div class="header-banner">
        <div
          class="banner-content"
          :class="{ 'without-college-logo': collegeName[productId].showLogo === false }"
        >
          <!-- 原 Banner 保留，恢复方式见 config.js 的 showShandongUniversityLogo 开关。 -->
          <img
            :src="collegeName[productId].logo"
            :alt="collegeName[productId].showLogo === false ? '' : collegeName[productId].name"
            class="banner-image"
          />
          <div
            v-if="collegeName[productId].showLogo === false"
            class="banner-titles"
          >
            <p class="banner-project-title">新未来健康工程</p>
            <p class="banner-entry-title">客户信息录入</p>
          </div>
        </div>
      </div>

      <!-- 表单区域 -->
      <div class="form-container">
        <!-- 机构信息 -->
        <div class="form-section">
          <div class="section-title">
            <div class="title-line"></div>
            <span class="title-text">机构信息</span>
            <div class="title-line"></div>
          </div>

          <div class="form-group">
            <label class="form-label">机构名称</label>
            <input
              type="text"
              class="form-input readonly-input"
              v-model="institutionData.institutionName"
              placeholder="机构名称"
              readonly
            />
          </div>

          <div
            v-if="isAreaRequired"
            class="form-group area-picker"
            @click="showAreaPicker = true"
          >
            <label class="form-label">{{ areaLabel }}</label>
            <input
              type="text"
              class="form-input"
              v-model="institutionData.areaName"
              :placeholder="`请选择${areaLabel}`"
              readonly
            />
            <van-icon name="arrow" color="#999" />
          </div>
          <van-popup v-model="showAreaPicker" position="bottom">
            <van-picker
              show-toolbar
              :title="`请选择${areaLabel}`"
              :columns="areaOptions"
              @confirm="onConfirmArea"
              @cancel="showAreaPicker = false"
            />
          </van-popup>

          <div class="form-group">
            <label class="form-label">业务员姓名</label>
            <input
              type="text"
              class="form-input"
              v-model="institutionData.payPersonName"
              placeholder="请输入姓名"
              @input="handleInputChange"
            />
          </div>

          <div class="form-group">
            <label class="form-label">业务员工号</label>
            <input
              type="text"
              class="form-input"
              v-model="institutionData.payPersonNo"
              placeholder="请输入业务员工号"
              @input="handleInputChange"
            />
          </div>

          <div class="form-group">
            <label class="form-label">业务员手机号</label>
            <input
              type="tel"
              class="form-input"
              v-model="institutionData.payPersonPhone"
              placeholder="请输入手机号"
              @input="handleInputChange"
            />
          </div>
        </div>

        <!-- 客户信息列表 -->
        <div
          v-for="(customer, index) in customerList"
          :key="customer.id"
          class="customer-section"
        >
          <div class="form-section">
            <div class="section-title">
              <div class="title-line"></div>
              <span class="title-text">客户信息</span>
              <div class="title-line"></div>
            </div>

            <div class="form-group">
              <label class="form-label">客户姓名</label>
              <input
                type="text"
                class="form-input"
                v-model="customer.personName"
                placeholder="请输入姓名"
                @input="handleInputChange"
                @blur="handlePersonNameBlur(customer, index)"
              />
            </div>

            <div class="form-group">
              <label class="form-label">客户身份证号</label>
              <input
                type="text"
                class="form-input"
                v-model="customer.personIdCard"
                placeholder="请输入身份证号"
                @input="handleInputChange"
              />
            </div>

            <div class="form-group">
              <label class="form-label">客户手机号</label>
              <input
                type="tel"
                class="form-input"
                v-model="customer.personPhone"
                placeholder="请输入手机号"
                @input="handleInputChange"
              />
            </div>

            <div class="form-group">
              <label class="form-label">选择类型</label>
              <div class="product-selector">
                <div class="checkbox-group">
                  <div
                    class="checkbox-item"
                    @click="selectType(1, index)"
                  >
                    <div
                      class="checkbox"
                      :class="{ checked: customer.isStorage }"
                    >
                      <van-icon
                        v-if="customer.isStorage"
                        name="success"
                      />
                    </div>
                    <span class="checkbox-label">存储</span>
                  </div>
                  <div
                    class="checkbox-item"
                    @click="selectType(2, index)"
                    v-show="xwlCheckItem !== '无'"
                  >
                    <div
                      class="checkbox"
                      :class="{ checked: customer.isDetection }"
                    >
                      <van-icon
                        v-if="customer.isDetection"
                        name="success"
                      />
                    </div>
                    <span class="checkbox-label">{{ detectionLabel }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group" v-if="quoteReady && customer.isStorage">
              <label class="form-label">选择产品</label>
              <!-- 外层包装：确保并列，不嵌套 -->
              <div class="product-selector">
                <!-- 第一分支：普通产品 -->
                <div class="checkbox-group">
                  <div
                    v-for="product in productList"
                    :key="product.id"
                    class="checkbox-item"
                    @click="selectProduct(product.id, index)"
                  >
                    <div
                      class="checkbox"
                      :class="{ checked: customer.productId === product.id }"
                    >
                      <van-icon
                        v-if="customer.productId === product.id"
                        name="success"
                      />
                    </div>
                    <span class="checkbox-label">{{ product.name }} ¥{{ product.price }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 操作按钮 - 只在有多个客户时显示 -->
          <div v-if="customerList.length > 1" class="customer-actions">
            <button class="btn-delete" @click="deleteCustomer(index)">
              删除此客户
            </button>
            <button class="btn-clear" @click="clearCustomer(index)">
              清空信息
            </button>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="action-buttons">
          <button class="btn btn-continue" @click="handleContinue">
            继续添加客户
          </button>
          <button class="btn btn-submit" :disabled="!quoteReady" @click="handleSubmit">提交</button>
        </div>

        <div v-if="!quoteReady" class="required-tip">
          <span v-if="quoteLoading">正在加载机构报价…</span>
          <template v-else>
            <span>暂时无法获取机构报价</span>
            <van-button size="mini" type="primary" @click="getPayOrgInfo">重新加载</van-button>
          </template>
        </div>

        <!-- 必填项提示 -->
        <div v-if="showRequiredTip" class="required-tip">
          <van-icon name="warning" />
          <span>以上均为必填项</span>
        </div>
      </div>
    </div>
    <van-overlay :show="loading">
      <van-loading size="40" vertical class="loadingDiv">支付中...</van-loading>
    </van-overlay>

    <!-- 客户选择弹窗 -->
    <van-popup
      v-model="showPersonSelectDialog"
      position="center"
      :style="{ width: '90%', borderRadius: '8px' }"
    >
      <div class="person-select-dialog">
        <div class="dialog-header">
          <h3 class="dialog-title">请选择客户信息</h3>
          <van-icon
            name="cross"
            size="20"
            color="#999"
            @click="closePersonSelectDialog"
          />
        </div>
        <div class="person-list">
          <div
            v-for="(person, index) in personSelectList"
            :key="index"
            class="person-item"
            @click="selectPerson(person, index)"
          >
            <div class="person-name">{{ person.personName }}</div>
            <div class="person-info">
              <span class="info-label">手机号：</span>
              <span class="info-value">{{
                maskPhone(person.personPhone)
              }}</span>
            </div>
            <div class="person-info">
              <span class="info-label">身份证号：</span>
              <span class="info-value">{{
                maskIdCard(person.personIdCard)
              }}</span>
            </div>
          </div>
        </div>
        <div class="dialog-actions">
          <van-button
            round
            type="default"
            class="cancel-btn"
            @click="closePersonSelectDialog"
          >
            取消
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  onGetPayConfigByWechatXinWeiLai,
  onCheckIdCard,
} from "@/api/medical-university";
import { selPayOrgInfoByOrgId, selectPersonByOrgldAndName } from "@/api";
import { storageTerms, college } from "./config";
export default {
  name: "CollegeIndex",
  data() {
    return {
      collegeName: college,
      loading: false,
      orgId: "",
      institutionData: {
        institutionName: "",
        areaName: "",
        payPersonName: "",
        payPersonNo: "",
        payPersonPhone: "",
      },
      showAreaPicker: false,
      productList: [],
      quoteReady: false,
      quoteLoading: false,

      customerList: [
        {
          id: 1,
          personName: "",
          personIdCard: "",
          personPhone: "",
          type: null, // 1: 存储, 2: 检测, 3: 同时选择, null: 未选择
          isStorage: false, // 是否选择存储
          isDetection: false, // 是否选择检测
          productId: '',
          orderNo: this.generateOrderNo(),
        },
      ],
      showRequiredTip: false,
      showConfirmation: false,
      orderData: {
        orderNumber: "",
        orderTime: "",
      },
      // 客户选择弹窗相关
      showPersonSelectDialog: false,
      personSelectList: [],
      currentCustomerIndex: -1, // 当前正在编辑的客户索引
      productId: '0',
      xwlCheckItem: "无",
    };
  },
  mounted() {
    // 页面加载时恢复数据
    this.restoreDataFromStorage();
    this.getPayOrgInfo();
  },
  computed: {
    areaLabel() {
      return Number(this.orgId) === 11397 ? "地市" : "区县";
    },
    isAreaRequired() {
      return [10134, 11382, 11397].includes(Number(this.orgId));
    },
    areaOptions() {
      if (Number(this.orgId) === 11397) {
        return [
          "济南市",
          "青岛市",
          "淄博市",
          "枣庄市",
          "东营市",
          "烟台市",
          "潍坊市",
          "济宁市",
          "泰安市",
          "威海市",
          "日照市",
          "莱芜市",
          "临沂市",
          "德州市",
          "聊城市",
          "滨州市",
          "菏泽市",
        ];
      }
      if (Number(this.orgId) === 11382) {
        return ["城区", "泰山区", "岱岳区", "宁阳县", "东平县", "新泰市", "肥城市"];
      }
      return [
        "淄川区",
        "张店区",
        "博山区",
        "临淄区",
        "周村区",
        "桓台县",
        "高青县",
        "沂源县",
      ];
    },
    // 检测项目展示名：检测-M21 / 检测-VPF
    detectionLabel() {
      return this.xwlCheckItem ? `检测-${this.xwlCheckItem}` : '检测';
    },
    // 获取URL中的id参数
    currentId() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get("id") || "default";
    },
    getTotalAmount() {
      const totalCents = this.customerList.reduce((total, customer) => {
        if (customer.isStorage) {
          return total + Math.round(this.getCustomerPrice(customer) * 100);
        }
        return total;
      }, 0);
      return totalCents / 100;
    },
    hasStorageType() {
      return this.customerList.some(customer => customer.isStorage);
    },
    getPayButtonText() {
      const hasStorage = this.customerList.some(customer => customer.isStorage);
      const hasDetection = this.customerList.some(customer => customer.isDetection);
      const hasBoth = this.customerList.some(customer => customer.isStorage && customer.isDetection);
      
      if (hasBoth || hasStorage) {
        return '去支付';
      } else if (hasDetection) {
        return '提交';
      }
      return '去支付';
    },
  },
  created() {
    // 优先从 URL 获取 orgId，如果没有则从 localStorage 获取
    const urlParams = new URLSearchParams(window.location.search);
    this.orgId = urlParams.get("orgId") || localStorage.getItem("orgId") || "";
    // 老药科大二维码只有 orgId，不能套用上一次山一大的产品类型。
    const productId = urlParams.get("productId") ||
      (urlParams.has("orgId") ? "0" : localStorage.getItem("productId"));
    this.productId = productId === "32" ? "32" : "0";
  },
  methods: {
    onConfirmArea(value) {
      this.institutionData.areaName = value;
      this.showAreaPicker = false;
      this.handleInputChange();
    },
    async getPayOrgInfo() {
      if (this.quoteLoading) {
        return;
      }
      this.quoteReady = false;
      this.quoteLoading = true;
      try {
        const res = await selPayOrgInfoByOrgId({
          orgId: this.orgId,
          xwlProductId: Number(this.productId),
        });
        const data = res && res.data;
        const prices = data && data.xwlStoragePrices;
        if (!res || Number(res.code) !== 200 || !prices || typeof prices !== "object" || Array.isArray(prices)) {
          this.$toast((res && res.msg) || "暂时无法获取机构报价，请重试");
          return;
        }
        this.productList = storageTerms
          .filter(term => Object.prototype.hasOwnProperty.call(prices, term.id))
          .map(term => ({ ...term, price: Number(prices[term.id]) }));
        if (this.productList.some(product => !Number.isFinite(product.price) || product.price <= 0)) {
          this.$toast("机构报价无效，请联系管理员");
          return;
        }
        this.institutionData.institutionName = data.saleOrgName;
        this.xwlCheckItem = data.xwlCheckItem || "无";
        if (this.xwlCheckItem === "无") {
          this.customerList.forEach(customer => {
            if (customer.isDetection) {
              customer.isDetection = false;
              customer.type = customer.isStorage ? 1 : null;
            }
          });
        }
        this.quoteReady = true;
        this.syncCustomerProducts();
        this.saveDataToStorage();
      } catch (error) {
        this.$toast("暂时无法获取机构报价，请重试");
      } finally {
        this.quoteLoading = false;
      }
    },
    // 生成订单号：yyyyMMddHHmmss + 6位随机数
    generateOrderNo() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hour = String(now.getHours()).padStart(2, "0");
      const minute = String(now.getMinutes()).padStart(2, "0");
      const second = String(now.getSeconds()).padStart(2, "0");

      const timestamp = `${year}${month}${day}${hour}${minute}${second}`;
      const randomNum = Math.floor(Math.random() * 1000000)
        .toString()
        .padStart(6, "0");

      return `${timestamp}${randomNum}`;
    },
    // localStorage相关方法
    saveDataToStorage() {
      try {
        // 获取现有的所有数据
        const allData = this.getAllStoredData();

        // 更新当前id的数据
        allData[this.currentId] = {
          institutionData: this.institutionData,
          customerList: this.customerList,
          timestamp: Date.now(),
        };

        // 保存到localStorage
        localStorage.setItem("college_form_data_10", JSON.stringify(allData));
      } catch (error) {
        console.error("保存数据失败:", error);
      }
    },
    getAllStoredData() {
      try {
        const savedData = localStorage.getItem("college_form_data_10");
        return savedData ? JSON.parse(savedData) : {};
      } catch (error) {
        console.error("获取存储数据失败:", error);
        return {};
      }
    },
    restoreDataFromStorage() {
      try {
        const allData = this.getAllStoredData();
        const currentData = allData[this.currentId];

        if (currentData) {
          // 检查数据是否过期（24小时）
          const isExpired =
            Date.now() - currentData.timestamp > 24 * 60 * 60 * 1000;
          if (!isExpired) {
            // 保持机构名称不变，只恢复其他数据
            const savedInstitutionData = currentData.institutionData || {};
            this.institutionData = {
              ...this.institutionData,
              ...savedInstitutionData,
              institutionName: this.institutionData.institutionName, // 保持从medical_university_user获取的机构名称
            };
            this.customerList = currentData.customerList || this.customerList;
            // 缓存会跨机构恢复，产品价格必须以当前机构的配置为准
            this.syncCustomerProducts();
            this.saveDataToStorage();
          } else {
            // 数据过期，清除当前id的数据
            this.clearCurrentIdData();
          }
        }
      } catch (error) {
        console.error("恢复数据失败:", error);
        this.clearCurrentIdData();
      }
    },
    clearCurrentIdData() {
      try {
        const allData = this.getAllStoredData();
        delete allData[this.currentId];
        localStorage.setItem("college_form_data_10", JSON.stringify(allData));
      } catch (error) {
        console.error("清除当前id数据失败:", error);
      }
    },
    clearStorageData() {
      // 支付后，清除客户信息缓存，保留机构信息
      try {
        const allData = this.getAllStoredData();
        if (allData[this.currentId]) {
          // 只保留机构信息，清除客户信息
          allData[this.currentId] = {
            institutionData: allData[this.currentId].institutionData || {},
            customerList: [
              {
                id: 1,
                personName: "",
                personIdCard: "",
                personPhone: "",
                type: null,
                isStorage: false,
                isDetection: false,
                productId: "",
                orderNo: this.generateOrderNo(),
              },
            ],
            timestamp: Date.now(),
          };
          localStorage.setItem("college_form_data_10", JSON.stringify(allData));
        }
      } catch (error) {
        console.error("清除客户信息缓存失败:", error);
      }
    },
    handleInputChange() {
      this.hideRequiredTip();
      this.saveDataToStorage();
    },
    // 客户姓名失焦事件处理
    async handlePersonNameBlur(customer, index) {
      // 如果没有输入姓名，不进行查询
      if (!customer.personName || !customer.personName.trim()) {
        return;
      }

      // 如果没有 orgId，不进行查询
      if (!this.orgId) {
        return;
      }
      console.log(customer.personName.trim());
      try {
        const res = await selectPersonByOrgldAndName({
          orgId: this.orgId, // 注意：API参数名是orgld（可能是拼写错误，但按接口要求使用）
          personName: decodeURI(customer.personName.trim()),
        });

        // 如果返回成功且有数据
        if (
          res &&
          res.code === 200 &&
          res.data &&
          Array.isArray(res.data) &&
          res.data.length > 0
        ) {
          // 如果只有一条数据，直接回填
          if (res.data.length === 1) {
            const personData = res.data[0];

            // 回填客户信息（只回填手机号和身份证号，姓名保持用户输入的值）
            if (personData.personPhone) {
              this.$set(
                this.customerList[index],
                "personPhone",
                personData.personPhone
              );
            }
            if (personData.personIdCard) {
              this.$set(
                this.customerList[index],
                "personIdCard",
                personData.personIdCard
              );
            }

            // 保存数据到 localStorage
            this.saveDataToStorage();
          } else {
            // 如果有多条数据，显示选择弹窗
            this.personSelectList = res.data;
            this.currentCustomerIndex = index;
            this.showPersonSelectDialog = true;
          }
        }
      } catch (error) {
        console.error("查询客户信息失败:", error);
        // 静默失败，不提示用户
      }
    },
    // 选择客户信息
    selectPerson(person, index) {
      if (
        this.currentCustomerIndex >= 0 &&
        this.currentCustomerIndex < this.customerList.length
      ) {
        // 回填客户信息（只回填手机号和身份证号，姓名保持用户输入的值）
        if (person.personPhone) {
          this.$set(
            this.customerList[this.currentCustomerIndex],
            "personPhone",
            person.personPhone
          );
        }
        if (person.personIdCard) {
          this.$set(
            this.customerList[this.currentCustomerIndex],
            "personIdCard",
            person.personIdCard
          );
        }

        // 保存数据到 localStorage
        this.saveDataToStorage();
      }

      // 关闭弹窗
      this.closePersonSelectDialog();
    },
    // 关闭客户选择弹窗
    closePersonSelectDialog() {
      this.showPersonSelectDialog = false;
      this.personSelectList = [];
      this.currentCustomerIndex = -1;
    },
    // 手机号脱敏：只显示前3位和后4位
    maskPhone(phone) {
      if (!phone || phone.length < 7) {
        return phone || "";
      }
      const prefix = phone.substring(0, 3);
      const suffix = phone.substring(phone.length - 4);
      const mask = "*".repeat(phone.length - 7);
      return `${prefix}${mask}${suffix}`;
    },
    // 身份证号脱敏：只显示前3位和后4位
    maskIdCard(idCard) {
      if (!idCard || idCard.length < 7) {
        return idCard || "";
      }
      const prefix = idCard.substring(0, 3);
      const suffix = idCard.substring(idCard.length - 4);
      const mask = "*".repeat(idCard.length - 7);
      return `${prefix}${mask}${suffix}`;
    },
    // 根据产品ID获取产品信息
    getProductById(productId) {
      return this.productList.find((product) => product.id === Number(productId));
    },

    // 获取产品期限文本
    getProductTerm(productId) {
      const product = this.getProductById(productId);
      return product ? product.term : "";
    },
    // 获取客户价格
    getCustomerPrice(customer) {
      const product = this.getProductById(customer.productId);
      return product ? product.price : 0;
    },
    // 报价加载完成后才校验缓存中的年期；缓存金额不用于显示或支付。
    syncCustomerProducts() {
      if (!this.quoteReady) {
        return;
      }
      this.customerList.forEach(customer => {
        const product = this.getProductById(customer.productId);
        customer.productId = customer.isStorage && product ? product.id : "";
      });
    },
    selectType(type, index) {
      if (!this.quoteReady) {
        return;
      }
      const customer = this.customerList[index];
      if (type === 1) {
        if (!customer.isStorage && !this.productList.length) {
          this.$toast("当前机构暂无可支付的存储项目");
          return;
        }
        customer.isStorage = !customer.isStorage;
        if (!customer.isStorage) {
          customer.productId = "";
        }
      } else if (type === 2 && this.xwlCheckItem !== "无") {
        customer.isDetection = !customer.isDetection;
      }

      // 更新type字段：1=存储, 2=检测, 3=同时选择
      if (customer.isStorage && customer.isDetection) {
        customer.type = 3;
      } else if (customer.isStorage) {
        customer.type = 1;
      } else if (customer.isDetection) {
        customer.type = 2;
      } else {
        customer.type = null;
      }
      
      this.saveDataToStorage();
    },
    selectProduct(productId, index) {
      if (!this.quoteReady || !this.getProductById(productId)) {
        return;
      }
      this.customerList[index].productId = productId;
      this.saveDataToStorage();
    },
    handleContinue() {
      // 添加新客户
      const newId = Math.max(...this.customerList.map((c) => c.id)) + 1;
      this.customerList.push({
        id: newId,
        personName: "",
        personIdCard: "",
        personPhone: "",
        type: null,
        isStorage: false,
        isDetection: false,
        productId: "",
        orderNo: this.generateOrderNo(),
      });

      // 保存数据到localStorage
      this.saveDataToStorage();

      // 滚动到页面底部
      this.$nextTick(() => {
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: "smooth",
        });
      });
    },
    deleteCustomer(index) {
      if (this.customerList.length > 1) {
        this.customerList.splice(index, 1);
        this.saveDataToStorage();
      }
    },
    clearCustomer(index) {
      // 只清空当前客户的信息，保留ID
      this.customerList[index].personName = "";
      this.customerList[index].personIdCard = "";
      this.customerList[index].personPhone = "";
      this.customerList[index].type = null;
      this.customerList[index].isStorage = false;
      this.customerList[index].isDetection = false;
      this.customerList[index].productId = "";

      this.customerList[index].orderNo = this.generateOrderNo(); // 重新生成订单号
      this.saveDataToStorage();
    },
    async handleSubmit() {
      if (!this.quoteReady) {
        return;
      }
      // 表单验证
      if (!this.validateForm()) {
        this.showRequiredTip = true;
        return;
      }

      // 隐藏提示
      this.showRequiredTip = false;

      const checkParams = this.customerList.map((customer) => ({
        personName: customer.personName,
        personIdCard: customer.personIdCard,
      }));

      let loadingToast = null;
      try {
        loadingToast = this.$toast.loading({
          duration: 0,
          forbidClick: true,
          message: "身份证校验中...",
        });
        const res = await onCheckIdCard(checkParams);
        if (!res || res.code !== 200) {
          this.$toast((res && res.msg) || "身份证校验失败");
          return;
        }
      } catch (error) {
        console.error("身份证校验失败", error);
        this.$toast("身份证校验失败");
        return;
      }
      if (loadingToast) {
        loadingToast.clear();
      }

      // 生成订单信息
      this.orderData.orderNumber = this.generateOrderNumber();
      this.orderData.orderTime = this.getCurrentTime();

      // 显示确认页面
      this.showConfirmation = true;
    },
    validateForm() {
      // 验证机构信息
      const institutionValid =
        this.institutionData.institutionName &&
        this.institutionData.payPersonName &&
        this.institutionData.payPersonNo &&
        this.institutionData.payPersonPhone;
      const areaValid =
        !this.isAreaRequired || this.institutionData.areaName;

      // 验证所有客户信息
      const customersValid = this.customerList.every(
        (customer) => {
          const basicInfoValid = customer.personName &&
            customer.personIdCard &&
            customer.personPhone &&
            (customer.isStorage || customer.isDetection); // 必须至少选择一种类型
          
          if (customer.isStorage) {
            // 存储类型需要产品信息
            return basicInfoValid && Boolean(this.getProductById(customer.productId));
          } else if (customer.isDetection) {
            // 检测类型只需要基本信息
            return basicInfoValid;
          }
          return false;
        }
      );

      return institutionValid && areaValid && customersValid;
    },
    hideRequiredTip() {
      this.showRequiredTip = false;
    },
    generateOrderNumber() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      const random = Math.floor(Math.random() * 1000)
        .toString()
        .padStart(3, "0");
      return `${year}${month}${day}${hours}${minutes}${seconds}${random}`;
    },
    getCurrentTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    goBack() {
      this.showConfirmation = false;
    },
    async goToPay() {
      if (!this.quoteReady || this.loading) {
        return;
      }
      // 提交前再校验一次，支付金额不信任缓存或页面状态中的 productPrice
      const hasInvalidStorageProduct = this.customerList.some(
        customer => customer.isStorage && !this.getProductById(customer.productId)
      );
      if (hasInvalidStorageProduct) {
        this.$toast("当前机构的存储产品已变更，请重新选择");
        this.showConfirmation = false;
        return;
      }

      // 判断是否有存储类型和检测类型
      const hasStorage = this.customerList.some(customer => customer.isStorage);
      const hasDetection = this.customerList.some(customer => customer.isDetection);
      
      // 确定订单类型：如果同时选择存储和检测，type=3；否则根据选择的类型决定
      let type;
      if (hasStorage && hasDetection) {
        type = 3; // 同时选择存储和检测
      } else if (hasStorage) {
        type = 1; // 只有存储
      } else if (hasDetection) {
        type = 2; // 只有检测
      } else {
        type = 1; // 默认
      }
      
      const itemList = this.customerList.map(customer => {
        const item = { ...customer };
        if (customer.isStorage) {
          const currentProduct = this.getProductById(customer.productId);
          item.productId = currentProduct.id;
          item.productPrice = currentProduct.price;
        }
        // 如果只选择检测，不需要产品信息
        if (customer.isDetection && !customer.isStorage) {
          item.productId = null;
          item.productPrice = null;
        }
        // 更新item的type字段
        if (customer.isStorage && customer.isDetection) {
          item.type = 3;
        } else if (customer.isStorage) {
          item.type = 1;
        } else if (customer.isDetection) {
          item.type = 2;
        }
        return item;
      });

      const params = {
        ...this.institutionData,
        wxCode: localStorage.getItem("code") || "",
        saleOrgId: this.orgId,
        type: type, // 传入类型参数：1是存储，2是检测
        itemList: itemList,
      };
      if (this.productId !== '0') {
        params.productId = Number(this.productId) 
      }
      // 跳转到支付页面或处理支付逻辑
      this.loading = true;
      try {
        const res = await onGetPayConfigByWechatXinWeiLai(params);
        console.log("res", res);
        if (res && Number(res.code) === 200) {
          // 支付成功后清除客户信息缓存，保留机构信息
          this.clearStorageData();
          
          // 根据类型执行不同逻辑
          if (type === 2 && !hasStorage) {
            // 只有检测类型，直接跳转到成功页（不需要支付）
            this.loading = false;
            // 如果有payNo，传递payNo，否则直接显示成功
            const payNo = res.data?.payNo || '';
            if (payNo) {
              window.location.href = `https://yisheng.healthmore.net/collegeInfoSuccess?payNo=${payNo}`;
            } else {
              this.$router.push('/collegeInfoSuccess');
            }
          } else {
            // 存储类型或同时选择（type=3），需要支付，唤起微信支付
            this.weixinPay(res.data);
          }
        } else {
          this.loading = false;
          this.$toast((res && res.msg) || "支付请求失败，请稍后重试");
          if (res && Number(res.code) === 409) {
            this.showConfirmation = false;
            await this.getPayOrgInfo();
          }
        }
      } catch (error) {
        this.loading = false;
        this.$toast("支付请求失败，请稍后重试");
      }
    },
    //唤起微信支付
    async weixinPay(weixinPayParam) {
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
        }
      } else {
        this.onBridgeReady(weixinPayParam);
      }
    },

    async onBridgeReady(weixinPayParam) {
      let payNoDiy = weixinPayParam.payNo;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: weixinPayParam.appId,
          timeStamp: weixinPayParam.timeStamp,
          nonceStr: weixinPayParam.nonceStr,
          package: weixinPayParam.packages,
          signType: weixinPayParam.signType,
          paySign: weixinPayParam.paySign,
        },
        function (res) {
          window.location.href =
            "https://yisheng.healthmore.net/settleInfoSuccess?payNo=" +
            payNoDiy;
          //this.$router.push(`/paysuccess?payNo=${payNoDiy}`);
        }
      );
    },
  },
};
</script>

<style scoped>
.loadingDiv {
  position: absolute;
  left: 42%;
  top: 40%;
}
.college-page {
  min-height: 100vh;
  /* background: linear-gradient(to bottom, #f5c485 100%, #feddbd 100%); */
  background: linear-gradient(
    268deg,
    rgba(245, 196, 133, 1) 0.61%,
    rgba(254, 221, 189, 1) 97.34%
  );
}

/* 头部banner区域 */
.header-banner {
  /* background: linear-gradient(135deg, #2c3e50, #34495e); */
  /* padding: 20px; */
  position: relative;
  /* min-height: 200px; */
}

.banner-content {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.banner-image {
  width: 100%;
  height: auto;
  max-width: 100%;
}

/* 隐藏 Logo 时压缩顶部留白；恢复开关后自动使用原 Banner 尺寸。 */
.banner-content.without-college-logo {
  position: relative;
  margin-bottom: 16px;
}

.without-college-logo .banner-image {
  height: 160px;
  object-fit: cover;
  object-position: bottom;
}

/* 无学校 Logo 的背景单独叠加业务标题，录入和信息确认页面共用。 */
.banner-titles {
  position: absolute;
  top: 26px;
  left: 0;
  right: 0;
  color: #f4ce98;
  text-align: center;
}

.banner-project-title {
  margin: 0;
  font-size: 24px;
  font-weight: 900;
  font-style: italic;
}

.banner-entry-title {
  margin: 12px 0 0;
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 3px;
}

.project-title {
  color: white;
  font-size: 18px;
  text-align: center;
  margin-bottom: 10px;
}

.page-title {
  color: #f39c12;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
}

.decorative-line {
  position: absolute;
  right: 20px;
  top: 50px;
  width: 2px;
  height: 100px;
  background: #f39c12;
  border-radius: 1px;
}

.decorative-line::before {
  content: "";
  position: absolute;
  top: -5px;
  right: -3px;
  width: 8px;
  height: 8px;
  background: #f39c12;
  border-radius: 50%;
}

/* 表单区域 */
.form-container {
  background: transparent;
  padding: 10px 20px 30px 20px;
  margin-top: -20px;
  border-radius: 20px 20px 0 0;
  min-height: calc(100vh - 180px);
}

.form-section {
  margin-bottom: 20px;
}

.section-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.title-line {
  flex: 1;
  height: 1px;
  background: #fff;
}

.title-text {
  margin: 0 15px;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
}

.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  background: #f7f0e6;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: none;
}

.form-label {
  min-width: 100px;
  color: #4f4f4f;
  font-weight: bold;
  font-size: 16px;
  margin-right: 15px;
}

.form-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
  color: #6c6c6c;
  background: transparent;
}

.form-input::placeholder {
  color: #999;
}

.readonly-input {
  background-color: #f5f5f5;
  color: #666;
  cursor: not-allowed;
}

.checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 20px 30px;
  margin-top: 0;
}

.checkbox-item {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.checkbox {
  width: 20px;
  height: 20px;
  border: 2px solid #ddd;
  border-radius: 4px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.checkbox .van-icon {
  font-size: 12px;
}

.checkbox.checked {
  background: #4caf50;
  border-color: #4caf50;
  color: white;
}

.checkbox-label {
  font-size: 14px;
  color: #333;
}

/* 客户操作按钮 */
.customer-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  /* margin-top: 15px; */
  padding: 0;
  margin-bottom: 20px;
}

.btn-delete {
  background: #e98b8b;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
  width: auto;
  min-width: 90px;
}

.btn-delete:hover {
  background: #d67a7a;
}

.btn-clear {
  background: transparent;
  color: #3370ff;
  border: none;
  font-size: 12px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s;
  padding: 10px 12px;
  width: auto;
}

.btn-clear:hover {
  color: #0056b3;
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  gap: 20px;
  margin-bottom: 5px;
  justify-content: center;
}

.btn {
  flex: 1;
  height: 50px;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  background: linear-gradient(to bottom, #5a5a5a, #4a4a4a);
  color: #f4ce98;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.btn:hover {
  background: linear-gradient(to bottom, #4a4a4a, #3a3a3a);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.btn-continue {
  background: linear-gradient(to bottom, #5a5a5a, #4a4a4a);
}

.btn-continue:hover {
  background: linear-gradient(to bottom, #4a4a4a, #3a3a3a);
}

.btn-submit {
  background: linear-gradient(to bottom, #5a5a5a, #4a4a4a);
}

.btn-submit:hover {
  background: linear-gradient(to bottom, #4a4a4a, #3a3a3a);
}

/* 必填项提示 */
.required-tip {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #dc3545;
  font-size: 12px;
  margin-left: 20px;
  margin-top: 5px;
  padding-right: 15px;
}

.required-tip .van-icon {
  margin-right: 5px;
  color: #dc3545;
}

/* 信息确认页面样式 */
.confirmation-page {
  min-height: 100vh;
  /* background: linear-gradient(to bottom, #f5c485 100%, #feddbd 100%); */
}

.confirmation-content {
  background: transparent;
  padding: 10px 20px 30px 20px;
  margin-top: -20px;
  border-radius: 20px 20px 0 0;
  min-height: calc(100vh - 180px);
}

.customer-confirmation-card {
  background: linear-gradient(
    91.32deg,
    rgba(246, 196, 133, 1) 1.35%,
    rgba(253, 219, 183, 1) 98.28%
  );
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.customer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.customer-name {
  color: #101010;
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}

.total-amount {
  color: #101010;
  font-size: 12px;
}

.amount {
  color: #4caf50;
  font-weight: bold;
  font-size: 16px;
}

.product-info {
  color: rgba(79, 79, 79, 0.85);
  font-size: 14px;
  margin-bottom: 15px;
}

.product-term {
  color: #4caf50;
  font-size: 16px;
  font-weight: bold;
}

.customer-details {
  /* color: #666; */
  font-size: 14px;
  color: #4f4f4f;
}

.detail-item {
  margin-bottom: 5px;
}

.total-summary {
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  /* margin-top: 20px; */
}

.total-label {
  color: #424146;
  font-size: 14px;
}

.total-value {
  color: #424146;
  font-size: 16px;
  font-weight: bold;
}

/* 确认页面底部按钮 */
.confirmation-buttons {
  display: flex;
  gap: 40px;
  margin-top: 30px;
  justify-content: center;
}

.btn-back {
  background: linear-gradient(to bottom, #5a5a5a, #4a4a4a);
  border: none;
  border-radius: 25px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  flex: 1;
}

.btn-back:hover {
  background: linear-gradient(to bottom, #4a4a4a, #3a3a3a);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.btn-pay {
  background: linear-gradient(to bottom, #5a5a5a, #4a4a4a);
  border: none;
  border-radius: 25px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  flex: 1;
}

.btn-pay:hover {
  background: linear-gradient(to bottom, #4a4a4a, #3a3a3a);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

/* 客户选择弹窗样式 */
.person-select-dialog {
  padding: 20px;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
}

.person-select-dialog .dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.person-select-dialog .dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.person-select-dialog .person-list {
  flex: 1;
  overflow-y: auto;
  max-height: 400px;
  margin-bottom: 20px;
}

.person-select-dialog .person-item {
  padding: 15px;
  background: #f8f8f8;
  border-radius: 8px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.3s;
  border: 2px solid transparent;
}

.person-select-dialog .person-item:hover {
  background: #f0f0f0;
  border-color: #1989fa;
}

.person-select-dialog .person-item:active {
  transform: scale(0.98);
}

.person-select-dialog .person-name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.person-select-dialog .person-info {
  font-size: 14px;
  color: #666;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
}

.person-select-dialog .info-label {
  min-width: 70px;
  color: #999;
}

.person-select-dialog .info-value {
  color: #333;
  font-weight: 500;
}

.person-select-dialog .dialog-actions {
  display: flex;
  justify-content: center;
}

.person-select-dialog .cancel-btn {
  width: 100%;
  height: 44px;
}

/* 响应式设计 */
@media (max-width: 375px) {
  .form-label {
    min-width: 80px;
    font-size: 13px;
  }

  .checkbox-group {
    gap: 15px 20px;
  }

  .action-buttons {
    gap: 40px;
  }
}
</style>
